import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  usersList: [],
  status: 'idle',
  error: null,
};

const usersListSlice = createSlice({
  name: 'usersList',
  initialState,
  reducers: {
    setUsersList: (state, action) => {
      state.usersList = action.payload;
      state.status = 'succeeded';
      state.error = null;
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.status = 'failed';
    },
    setLoading: (state) => {
      state.status = 'loading';
    },
  },
});

export const { setUsersList, setError, setLoading } = usersListSlice.actions;
export default usersListSlice.reducer;
